import { render } from "./CardSettings.vue?vue&type=template&id=3be84cf8&scoped=true"
import script from "./CardSettings.vue?vue&type=script&lang=js"
export * from "./CardSettings.vue?vue&type=script&lang=js"

import "./CardSettings.vue?vue&type=style&index=0&id=3be84cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be84cf8"]])

export default __exports__